import React, { FC, ReactNode, useEffect, useState } from "react"
import { Button, PageTitle, ToastLevel, useIntl, useToast } from "@metsooutotec/modes-react-components";
import { observer } from "mobx-react-lite";
import { useLocation, useNavigate } from "react-router-dom";
import { SensorBatch } from "../models/sensor-batch-models";
import ListView from "../../../../components/utils/list-view/list-view";
import sensorBatchStore from '../stores/sensor-batch-store';
import { itemViewDetailsContainerStyles } from "../../../../components/common-style/common-style";
import { NavigationDeleteEntityOptions, NavigationModalOptions } from "../../../../components/utils/modal-helper";
import SensorBatchModal from "../components/sensor-batch-modal";
import LowSpinner from "../../../../components/common/low-spinner";
import { convertDateToDDMMMYY } from "../../../../components/utils/date-formatter-utils";

const SensorBatchListView: FC = observer(() => {
    const navigate = useNavigate();
    const { formatMessage } = useIntl();
    const location = useLocation();
    const { sensorBatches } = sensorBatchStore;
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const deleteParams: NavigationDeleteEntityOptions = location.state;
    const { deleted: DeletedSensorBatch, entityName: SensorBatchName } = deleteParams || {};
    const { setMessage } = useToast();
    const createSensorBatchModal = {
        open: () => {
            setIsCreateModalOpen(true);
        },
        close: (passed: boolean, sensorBatchId?: string, navigationSensorBatchOptions?: NavigationModalOptions) => {
            setIsCreateModalOpen(false);
            if (passed) {
                navigate(`${location.pathname}/${sensorBatchId}`, {
                    state: navigationSensorBatchOptions
                });
            }
        }
    }
    const showNotifier = (text: string) => {
        setMessage(text, ToastLevel.SUCCESS, 6000);
    }
    useEffect(() => {
        if (DeletedSensorBatch) {
                showNotifier(`You have deleted Sensor Batch '${SensorBatchName}'.`);

        }
        window.history.replaceState({}, document.title);
    }, [DeletedSensorBatch, SensorBatchName, deleteParams]);

    const template = [
        {
            headingKey: "headings.batchDate",
            cellFunc: (s: SensorBatch) => {
                return convertDateToDDMMMYY(s.batchDate);
            },
            isSearchable: true,
        },
        {
            headingKey: "headings.purchaseOrder",
            cellFunc: (s: SensorBatch) => s.purchaseOrder,
            isSearchable: true,
        },
        {
            headingKey: "headings.manufacturer",
            cellFunc: (s: SensorBatch) => s.manufacturer,
            isSearchable: true,
        }
        ,
        {
            headingKey: "headings.description",
            cellFunc: (s: SensorBatch) => s.description,
            isSearchable: true,
        }
    ];

    const rightPageButtons: ReactNode = (
        <>
            <Button icon="icon-plus-16" labelPosition="left" onClick={createSensorBatchModal.open} primary>{formatMessage("sensorBatch.create")}</Button>
        </>
    );
    const tableContainerStyles = {
        ...itemViewDetailsContainerStyles,
        height: '91%'
    };
    return (
        <>
            <PageTitle
                onPathChange={navigate}
                title={formatMessage("sensorBatches.title")}
                extraItems={rightPageButtons}
            />
            <div style={tableContainerStyles}>
                {

                    (sensorBatches.length < 1)
                        ? (<LowSpinner id={"sensorBatch.loading"} />)
                        : <ListView
                            noneYetKey={"sensorBatch.nonYet"}
                            template={template}
                            data={sensorBatches}
                            onClickRow={(s: SensorBatch) => navigate("/sensor-batches/" + s.id)}
                        />
                }
                <SensorBatchModal isOpen={isCreateModalOpen} onClose={createSensorBatchModal.close} />
            </div>
        </>
    );
});

export default SensorBatchListView;